<div
  fxLayout="column"
  fxLayoutAlign="center center"
  class="payka-loader"
  [ngStyle]="{'transform': 'scale(' + scaleFactor + ')'}"
>
  <div class="payka-loader-icon">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
